import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { Problem } from './components/Problem';
import { WhyItFailed } from './components/WhyItFailed';
import { UniqueMechanism } from './components/UniqueMechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsItFor } from './components/WhoIsItFor';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
import { initMetaPixel } from './lib/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-green-200 selection:text-green-900" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <OpeningHook data-id="element-3" />
        <Problem data-id="element-4" />
        <WhyItFailed data-id="element-5" />
        <UniqueMechanism data-id="element-6" />
        <WhatYouGet data-id="element-7" />
        <WhoIsItFor data-id="element-8" />
        <HowItWorks data-id="element-9" />
        <Proof data-id="element-10" />
        <FAQ data-id="element-11" />
        <Offer data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
    </div>;
}